import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Shop',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h(
        "g",
        {
          attrs: { fill: "none", stroke: "currentColor", "stroke-miterlimit": "10" }
        },
        [h("path", {
          attrs: { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M21.5 21.4l-1-14.9h-17l-1 14.9c0 .6.4 1.1 1 1.1h17c.6 0 1-.5 1-1.1z" }
        }), h("circle", {
          attrs: { cx: "8", cy: "10", r: "1.5" }
        }), h("circle", {
          attrs: { cx: "16", cy: "10", r: "1.5" }
        }), h("line", {
          attrs: { "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "18", y1: "19", x2: "3.3", y2: "19" }
        }), h("path", {
          attrs: { "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", d: "M8 9V3c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6" }
        })]
      )]
    );
  }
};